import { MutationHookOptions, useMutation } from '@apollo/client';
import createDepotMutation from './createDepotMutation.graphql';

export const useCreateDepotMutation = (
  options?: MutationHookOptions<
    CreateAccountDepotMutation,
    CreateAccountDepotMutationVariables
  >,
) => {
  return useMutation<
    CreateAccountDepotMutation,
    CreateAccountDepotMutationVariables
  >(createDepotMutation, {
    awaitRefetchQueries: true,
    // Refetch queries to update the depot list
    refetchQueries: ['ManagedDepotsFromPlatformAccount', 'ManagedDepots'],
    ...options,
  });
};
